import { lazy } from "react";

export const PaymentsPage = lazy(() => import("./paymentsPage"));
